import {appRoutes, mobileAppRoutes} from './appRoutes';

const menuItems = {
    items: [appRoutes],
    mobileItems: [mobileAppRoutes]
};

export default menuItems;
